const foreign_worker_group_schema = {
  view: "main",
  title: "Foreign Worker Profile Groups",
  entity: "Foreign Worker Groups",
  linkBack: {
    name: "Back to Foreign Worker Profiles",
    link: "/dashboard/profiles/foreign-worker/",
  },
  button: {
    name: "New Foreign Worker Group",
    style: "default",
  },
};

export default foreign_worker_group_schema;
